import React, { Component } from "react";
import PropTypes from "prop-types";
import style from "./styles";
import PopoverComponent from "../../molecules/Popover/Popover";
import { Popover } from "@rdc-npm/rdc-ui";
export default class Certification extends Component {
  state = { showPopover: false, selectedCertificate: "" };
  handleMouseEnter = (selectedCertificate) => {
    this.setState({ showPopover: true, selectedCertificate });
  };
  handleMouseLeave = () => {
    this.setState({ showPopover: false, selectedCertificate: "" });
  };
  render() {
    const {
      designations,
      ulPosition,
      marginTop,
      marginRight,
      marginBottom,
      marginLeft,
      pageName,
    } = this.props;
    const ulStyle = {
      position: ulPosition,
    };
    const certificationStyle = {
      marginTop: marginTop,
      marginRight: marginRight,
      marginBottom: marginBottom,
      marginLeft: marginLeft,
    };
    const combineCertification = pageName && pageName == "srp" ? true : false;
    let totalCertificationCount = 0;
    const customWidths = {
      xs: "200px",
      sm: "540px",
      md: "600px",
      lg: "600px",
    };
    return (
      <>
        <style jsx>{style}</style>
        <div
          className="desigations_certifications-icons"
          data-testid="component-certification"
          style={certificationStyle}>
          <ul style={ulStyle}>
            {designations &&
              designations.map((m, i) => {
                const name = m && m.name && m.name.toLowerCase();
                totalCertificationCount++;
                let showCert = true;
                if (
                  name === "lvnv" ||
                  name === "bsma" ||
                  name === "noct" ||
                  name === "tafl" ||
                  name === "pppa" ||
                  name === "trc" ||
                  name === "abrm" ||
                  name === "relay"
                ) {
                  showCert = false;
                }
                const finalClassName = "icon-certification-" + name;
                const { certificationDetails } = this.props;
                let certDetails = [];
                if (showCert) {
                  certDetails =
                    certificationDetails &&
                    certificationDetails.filter(
                      (certificate) => certificate.certName.toLowerCase() == name,
                    );
                }
                return (
                  <React.Fragment key={i}>
                    {showCert ? (
                      <>
                        <div className="popover-hover">
                          {combineCertification && i > 4 ? null : (
                            <>
                              <Popover
                                open={
                                  this.state.showPopover && name === this.state.selectedCertificate
                                }
                                onClose={this.handleMouseLeave}
                                customWidths={customWidths}
                                body={
                                  <PopoverComponent
                                    certificateName={this.state.selectedCertificate}
                                    certDetails={certDetails}
                                    showPopover={this.state.showPopover}
                                  />
                                }>
                                <i
                                  className={finalClassName}
                                  onMouseEnter={() => this.handleMouseEnter(name)}
                                  onMouseLeave={this.handleMouseLeave}></i>
                              </Popover>
                            </>
                          )}
                        </div>
                      </>
                    ) : null}
                  </React.Fragment>
                );
              })}
            {combineCertification && totalCertificationCount > 5 ? (
              <>
                <a className="icon-certification-extra pull-left">
                  {`${totalCertificationCount - 5}+`}
                </a>
              </>
            ) : null}
          </ul>
        </div>
      </>
    );
  }
}
Certification.defaultProps = {};
Certification.propTypes = {
  designations: PropTypes.array,
  certificationDetails: PropTypes.array,
  width: PropTypes.string,
  ulPosition: PropTypes.string,
  marginTop: PropTypes.string,
  marginRight: PropTypes.string,
  marginBottom: PropTypes.string,
  marginLeft: PropTypes.string,
  pageName: PropTypes.string,
};
